module.exports = __webpack_public_path__ + "static/media/3310.f5457cd5.jpg";